export default "__VITE_ASSET__BQpkO$iU__"